import { Badge } from 'antd';
import { SearchOutlined, MacCommandOutlined } from '@ant-design/icons';
import React from 'react';
import { MODAL_KEY } from './GlobalSearchModal';
import { useStoreActions, useStoreState } from '../../store';
import { createUseStyles } from 'react-jss';
import { useHotkeys } from 'react-hotkeys-hook';
import { GlobalSearchComponent } from './GlobalSearchModal';
export const SearchBar = () => {
  const toggled = useStoreState((state) => state.navigation.modals[MODAL_KEY]);
  const openModal = useStoreActions((actions) => actions.navigation.toggleModal);
  useHotkeys(
    'command+k',
    (event) => {
      event.preventDefault();
      openModal({ key: MODAL_KEY, open: true });
      document.getElementById('main-search-input')?.focus();
    },
    [toggled],
  );
  const handleModalClick = () => {
    openModal({ key: MODAL_KEY, open: true });
  };
  const useStyles = createUseStyles({
    badge: {
      fontSize: '16px',
    },
    icon: {
      padding: '4px',
      verticalAlign: 'middle',
      marginRight: '10px',
    },
    hotkey: {
      padding: '4px, 0, 4px, 0',
      verticalAlign: 'middle',
      marginRight: '10px',
      color: '#999',
    },
  });
  const classes = useStyles();
  return (
    <Badge className={classes.badge}>
      <span onClick={handleModalClick} className={classes.hotkey}>
        <MacCommandOutlined />
        +K
      </span>
      <SearchOutlined className={classes.icon} onClick={handleModalClick} />
      <GlobalSearchComponent />
    </Badge>
  );
};
